import React, { useMemo, useState } from "react";
import { getImageUrl } from "../../utils/imageUrl";

export default function RoomGallery({
  images = [],
  video = null,
}) {
  // Merge images + video into one gallery
  const media = useMemo(() => {
    const items = images.map((src) => ({
      type: "image",
      src,
    }));

    if (video) {
      items.push({
        type: "video",
        src: video,
      });
    }

    return items;
  }, [images, video]);

  const [index, setIndex] = useState(0);

  const current =
    media[index] || {
      type: "image",
      src: "/images/sample.jpg",
    };

  return (
    <div>
      {/* Main Preview */}
      <div className="rounded-2xl overflow-hidden bg-gray-100">
        {current.type === "image" ? (
          <img
            src={getImageUrl(current.src)}
            alt="Room"
            className="w-full h-96 object-cover"
          />
        ) : (
          <video
            src={getImageUrl(current.src)}
            controls
            className="w-full h-96 object-cover"
          />
        )}
      </div>

      {/* Thumbnails */}
      <div className="flex flex-wrap gap-3 mt-4">
        {media.map((item, i) => (
          <button
            key={i}
            type="button"
            onClick={() => setIndex(i)}
            className={`relative rounded-xl overflow-hidden border-2 transition
              ${
                i === index
                  ? "border-orange-500"
                  : "border-transparent"
              }`}
          >
            {item.type === "image" ? (
              <img
                src={getImageUrl(item.src)}
                alt=""
                className="w-32 h-24 object-cover"
              />
            ) : (
              <div className="relative">
                <video
                  src={getImageUrl(item.src)}
                  className="w-32 h-24 object-cover"
                  muted
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                  <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center">
                    ▶
                  </div>
                </div>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}